// extracted by mini-css-extract-plugin
export default {"root":"_2WHJi","transform":"tZNcA","swipeable":"_2UQHX","preview":"_3on8e","next":"_1_AHf","prev":"RZTjt"};